import { useState } from 'react';
import axios from 'axios';
import config from '../config';

const ImageUpload = ({ value, onChange, label = "Image" }) => {
    const [uploadMethod, setUploadMethod] = useState('url'); // 'url' or 'upload'
    const [uploading, setUploading] = useState(false);
    const [preview, setPreview] = useState(value || '');

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setUploading(true);
            const formData = new FormData();
            formData.append('image', file);

            const token = localStorage.getItem('token');
            const response = await axios.post(`${config.API_URL}/upload/image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            });

            const imageUrl = response.data.url;
            setPreview(imageUrl);
            onChange(imageUrl);
        } catch (error) {
            console.error('Image upload failed:', error);
            alert('Image upload failed: ' + (error.response?.data?.message || error.message));
        } finally {
            setUploading(false);
        }
    };

    const handleUrlChange = (e) => {
        const url = e.target.value;
        setPreview(url);
        onChange(url);
    };

    return (
        <div className="image-upload-container">
            <label className="form-label">{label}</label>

            <div className="upload-method-toggle">
                <label>
                    <input
                        type="radio"
                        value="url"
                        checked={uploadMethod === 'url'}
                        onChange={(e) => setUploadMethod(e.target.value)}
                    />
                    Image URL
                </label>
                <label>
                    <input
                        type="radio"
                        value="upload"
                        checked={uploadMethod === 'upload'}
                        onChange={(e) => setUploadMethod(e.target.value)}
                    />
                    Upload Image
                </label>
            </div>

            {uploadMethod === 'url' ? (
                <input
                    type="url"
                    className="form-input"
                    placeholder="https://example.com/image.jpg"
                    value={value || ''}
                    onChange={handleUrlChange}
                />
            ) : (
                <div className="file-upload-area">
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileUpload}
                        disabled={uploading}
                        className="form-input"
                    />
                    {uploading && <p className="upload-status">Uploading...</p>}
                </div>
            )}

            {preview && (
                <div className="image-preview">
                    <img src={preview} alt="Preview" />
                </div>
            )}
        </div>
    );
};

export default ImageUpload;
